import { BilletterieCustomerPaymentMode, type PaymentMethodPreset } from '@cpce/database/enums';
import { type BilletterieOrder, CUSTOMER_PAYMENT_MODE_PRESETS } from '@cpce/shared';
import { BadgeColor } from '@/components/Badge';

const NO_CUSTOMER_PAYMENT_MODE = 'none';

/** The billetterie admin's fixed list of the modes a salarié pays the CSE with. */
export const CUSTOMER_PAYMENT_MODE_OPTIONS = [
  { value: BilletterieCustomerPaymentMode.carte, label: 'Carte bancaire', color: BadgeColor.BLUE },
  { value: BilletterieCustomerPaymentMode.cheque, label: 'Chèque', color: BadgeColor.PURPLE },
  { value: BilletterieCustomerPaymentMode.especes, label: 'Espèces', color: BadgeColor.GREEN },
  { value: NO_CUSTOMER_PAYMENT_MODE, label: 'Non précisé', color: BadgeColor.GRAY },
];

export const customerPaymentModeValue = (order: BilletterieOrder) =>
  order.customerPaymentMode ?? NO_CUSTOMER_PAYMENT_MODE;

export const customerPaymentPreset = (order: BilletterieOrder): PaymentMethodPreset | undefined =>
  order.customerPaymentMode ? CUSTOMER_PAYMENT_MODE_PRESETS[order.customerPaymentMode] : undefined;

export const describePaymentMethods = (order: BilletterieOrder) =>
  order.paymentMethods.map((method) => method.label).join(' + ') || '-';
